import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { testimonials } from '../data/copy';
export function TestimonialsSection() {
  return <section className="defer-paint w-full bg-ink py-14 sm:py-20" aria-labelledby="testimonials-heading" data-id="element-210" data-mp="1n0ae5ipn6ux5">
      <div className="mx-auto max-w-6xl px-6" data-id="element-211" data-mp="1r142ueawsdr3">
        <SectionHeading title={<span id="testimonials-heading" data-id="element-213" data-mp="1qz9ip27gopo2">What handball coaches are saying</span>} data-id="element-212" data-mp="1qzt0mix43e23" />

        <ul className="mt-10 grid gap-4 md:grid-cols-3 md:gap-5" data-id="element-214" data-mp="1d0jmrpwdow1a">
          {testimonials.map((testimonial, index) => <li key={`${testimonial.role}-${index}`} className="flex flex-col rounded-3xl border border-line bg-navy p-6 sm:p-7" data-id="element-215" data-mp="1hyuwm0mob6ji" data-mpi={index}>
              <QuoteIcon className="h-7 w-7 text-accent" strokeWidth={1.8} aria-hidden="true" data-id="element-216" data-mp="18289t6ase5eu" />
              <blockquote className="mt-4 text-lg leading-relaxed text-fg" data-id="element-217" data-mp="2yfh0z2d44vkr">
                “{testimonial.quote}”
              </blockquote>
              <div className="mt-auto pt-6" data-id="element-218" data-mp="32g97voyiiodv">
                <p className="border-t border-line pt-5 font-display text-lg font-bold uppercase tracking-wide text-fg" data-id="element-219" data-mp="2v1kqmkvmm3u6">
                  {testimonial.role}
                </p>
                <p className="mt-0.5 text-sm text-muted" data-id="element-220" data-mp="2q0ewqjq8caj2">{testimonial.country}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}